import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

type RedirectingModalProps = {
  open: boolean;
  title: string;
  messageLines: string[];
};

export const RedirectingModal = ({ open, title, messageLines }: RedirectingModalProps) => (
  <Dialog open={open}>
    <DialogTitle
      sx={{
        fontWeight: 600,
        fontSize: { xs: '14px', sm: '16px', md: '18px' },
      }}
    >
      {title}
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ fontWeight: 600 }}>
        {messageLines.map((line, i) => (
          <span key={i}>
            {line}
            <br />
          </span>
        ))}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <CircularProgress />
      </Box>
    </DialogContent>
  </Dialog>
);
